export default "__VITE_ASSET__BsnKy39r__"